var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9584b4fa3aead4d4c79c82bd03a262a3a50ab106"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["nextjs@cultura-cardedeu"]={id:"9584b4fa3aead4d4c79c82bd03a262a3a50ab106"};
      